/** Компонента редактирование ссылочного значения 
 * Формирует список доступных ссылок с кнопкой "Удалит"ь ссылку (т.е. удаляется триплет с ссылкой)
 * и кнопку "Связать" с объектом.
 * 
 * По кнопке "Связать" отображается диалог выбора объекта. По Ok создаётся триплет с ссылкой
 * 
*/
import React from 'react';
import { connect } from 'react-redux';
import ButtonGroup from 'antd/lib/button/button-group';
import { Form, Icon, Input, Button, Row, Col } from 'antd';
import { AdmsAsset, RdfTriplet } from '../../redux';

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

const formItemLayout = {
//  wrapperCol: { xs: { span: 20 }, sm: { span: 18 }, },
};

/** Форма редактирования ссылочного значения */
class EditObjectPropertyForm extends React.Component {
  componentDidMount() {
    // To disable submit button at the beginning.
    this.props.form.validateFields();
  }

  handleSubmit = data => {
    console.log("EditObjectProperty.js", data);
    const {lang, uri, subject, value, dispatch} = this.props;
    this.props.dispatch(AdmsAsset.deleteValueInProperty(subject, uri, data));
    this.props.dispatch(RdfTriplet.EMPTY());
  };

  handleCancel = e => {
    e.preventDefault();
    this.props.dispatch(RdfTriplet.EMPTY());
  };

  render() {
    const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;
    const { lang, value } = this.props;
    // Only show error after a field is touched.
    const valueError = isFieldTouched('value') && getFieldError('value');
    const values = (value.startsWith("["))?JSON.parse(value):[value];
    console.log(this, values);
    return (
      <Form {...formItemLayout} layout="horizontal" >
        {values.map((data, index) => 
          <Row key={index}>
            <Col span={20}>
          <Form.Item validateStatus={valueError ? 'error' : ''} help={valueError || ''}>
            {getFieldDecorator('value'+index, {
              rules: [{ required: false, message: 'Please input your value!' }], initialValue:data,
            })(
              <Input disabled />,
            )}
          </Form.Item>
          </Col>
          <Col span={4}>
          <Form.Item>
            <ButtonGroup>
              <Button type="primary" onClick={() => this.handleSubmit(data)} icon="minus"></Button>
              <Button type="primary" icon="close" onClick={(e)=> this.handleCancel(e)}></Button>
            </ButtonGroup>
          </Form.Item>
          </Col>
          </Row>
        )}
      </Form>
    );
  }
}

function mapStateToProps(state, props) {
  const {vselected} = state;
  return {
      ...vselected
  };
}

export default Form.create({ name: 'object_edit_form' })(connect(mapStateToProps)(EditObjectPropertyForm));